import React from "react";
import { Routes, Route } from "react-router-dom";

import VH11Najdi from "./components/VH11Najdi";
import PogojiUporabe from "./components/PogojiUporabe";
import ONas from "./components/ONas";
import ZaPodjetja from "./components/ZaPodjetja";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<VH11Najdi />} />
      <Route path="/pogoji-uporabe" element={<PogojiUporabe />} />
      <Route path="/o-nas" element={<ONas />} />
      <Route path="/za-podjetja" element={<ZaPodjetja />} />
      {/* opcijsko še politika */}
      {/* <Route path="/politika-zasebnosti" element={<PolitikaZasebnosti />} /> */}
    </Routes>
  );
}